<template>
  <div class="jflow-process-box">
    <!-- <iframe ref="jpFrame" v-show="src" :src="src" style="width: 100%; height: 100%; border: medium none"></iframe> -->
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "JflowProcess",
  data() {
    return {
      src: "",
    };
  },
  mounted() {
    this.loadData();
    this.$emit('closeActionDialog', true); // 关闭弹框
  },

  methods: {
    loadData() {
      const { tableName, tableId, itemId } = this.$router.currentRoute.params;
      // http://cmsqas.lining.com/jflow/p/cs/task/page/approveAction
      const tableMap = {
        '249130100': '249130069',
        '249130182': '249130069',
        '249130183': '249130069',
        '249130185': '249130069',
        '249130190': '249130069',
        '249130229': '249130069',
        '249130233': '249130069',
        '249130245': '249130069',
        '249130318': '249130069',
        '249130319': '249130069',
        '249130320': '249130069',
        // '249130338': '249130069',
        '249130338': '249130100',
        '249130533': '249130069',
        '249130300': '249130078',
        '249130301': '249130078',
        '249130302': '249130078',
        '249130303': '249130078',
        '249130220': '249130082',
        '249130221': '249130082',
        '249130222': '249130082',
        '249130223': '249130082',
        '249130248': '249130082',
        '249130249': '249130082',
        '249130250': '249130082',
        '249130251': '249130082',
        '249130253': '249130082',
        '249130605': '249130082',
        '249130247': '249130089',
        '249130254': '249130089',
        '249130255': '249130089',
        '249130257': '249130089',
        '249130321': '249130108',
        '249130292': '249130122',
        '249130293': '249130122',
        '249130294': '249130122',
        '249130295': '249130122',
        '249130333': '249130163',
        '249130443': '249130163',
        '249130551': '249130166',
        '249130339': '249130169',
        '249130340': '249130169',
        '249130341': '249130169',
        '249130342': '249130169',
        '249130506': '249130169',
        '249130508': '249130169',
        '249130509': '249130169',
        '249130510': '249130169',
        '249130522': '249130169',
        '249130523': '249130522',
        '249130524': '249130169',
        '249130525': '249130169',
        '249130526': '249130169',
        '249130284': '249130170',
        '249130285': '249130170',
        '249130286': '249130170',
        '249130287': '249130170',
        '249130617': '249130170',
        '249130625': '249130170',
        '249130626': '249130170',
        '249130627': '249130628',
        '249130628': '249130170',
        '249130394': '249130171',
        '249130395': '249130171',
        '249130396': '249130171',
        '249130397': '249130171',
        '249130316': '249130173',
        '249130534': '249130173',
        '249130535': '249130173',
        '249130337': '249130277',
        '249130516': '249130476',
        '249130517': '249130476',
        '249130520': '249130476',
        '249130521': '249130476',
        '249130642': '249130640',
        '249130585': '249130583',
        '249130642': '249130640' 
      };
      //虚：实
      console.log('businessType :>> ', tableMap[tableId]);
      let param = {
        businessCode: itemId,
        userId: this.$store.state.global.userInfo.id,
        businessType: tableMap[tableId],
      };

      axios({
        url: "/jflow/p/cs/task/page/approveAction",
        method: "post",
        data: param,
      }).then((res) => {
        // console.log("res :>> ", res);
        if (res.status == 200 && res.data.resultCode == 0) {
          // http://106.14.47.161:18080/#/FlowChart?instanceId=3428
          // http://jflow.cmsqas.lining.com/#/FlowChart?instanceId=1985
          let instanceId = res.data.data.instanceId || res.data.data.lastInstanceId;
          if (!instanceId) {
            this.$emit('closeActionDialog', true); // 关闭弹框
            this.$Modal.fcError({
              title: "提示",
              content: "此单据没有经过审批流，无法查看流程进度"
            });
            return
          }
          let jflowOriginUrl = 'https://jflow-cms.lining.com' // prd
          if (window.location.origin.indexOf("127.0.0.1") > -1) {
            jflowOriginUrl = 'http://jflow.cmsdev.lining.com' //新dev
          } else if (window.location.origin.indexOf("r3.burgeon.cn:28888") > -1) {
            jflowOriginUrl = 'http://139.224.134.69:22333' // dev
          } else if (window.location.origin.indexOf("cmsqas.lining.com") > -1) {
            jflowOriginUrl = 'http://jflow.cmsqas.lining.com' //qa
          } else if(window.location.origin.indexOf("cmsdev.lining.com") > -1){
            jflowOriginUrl = 'http://jflow.cmsdev.lining.com' //新dev
          }
          let url = `${jflowOriginUrl}/#/FlowChart?instanceId=${instanceId}&rodomtime=${new Date().getTime() + Math.floor(Math.random() * 1000000)}`;
          console.log("url :>> ", url);
          // this.src = url;
          // this.$refs.jpFrame.contentWindow.location.reload(true)
          window.open(url,'_blank','width=860,height=660,menubar=no,toolbar=no, status=no,scrollbars=yes')
        }
      });
    },
  },
};
</script>

<style lang='less'>
.jflow-process-box {
  // width: 860px;
  // height: 660px;
}
</style>